export const DISPLAY_ICON_TEST_ID = 'pointModeDropdownDisplayIcon';

export const LABEL_ICON_TEST_ID = 'pointModeDropdownLabelIcon';

export const TEST_ID = 'pointModeDropdown';

export { POINT_MODE } from 'components/Map/constants';
